import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Region from "@/pages/Region";
import City from "@/pages/City";
import Resources from "@/pages/Resources";
import ResourceArticle from "@/pages/ResourceArticle";
import ImpactWall from "@/pages/ImpactWall";
import ImpactShare from "@/pages/ImpactShare";
import LogoOptions from "@/pages/LogoOptions";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
            <Route path="/regions/:slug" element={<Region />} />
            <Route path="/cities/:slug" element={<City />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<ResourceArticle />} />
            <Route path="/impact/wall" element={<ImpactWall />} />
            <Route path="/impact/share" element={<ImpactShare />} />
            <Route path="/logos" element={<LogoOptions />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <WhatsAppButton />
        <Toaster position="bottom-right" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
